var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';
var FloorsComponent = /** @class */ (function (_super) {
    __extends(FloorsComponent, _super);
    function FloorsComponent(injector, route) {
        var _this = _super.call(this, injector) || this;
        _this.route = route;
        return _this;
    }
    FloorsComponent.prototype.ngOnInit = function () {
        this.buildingFloor = this.route.snapshot.data.building_floor;
    };
    return FloorsComponent;
}(SeoAwareBaseComponent));
export { FloorsComponent };



// WEBPACK FOOTER //
// ./src/app/floors/floors.component.ts.pre-build-optimizer.js